
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'

var PersonChangeApplyPage = Vue.extend({})
Vue.component('personChangeApply-page', PersonChangeApplyPage)

export default {
  name: 'PersonChangeApplyPage',
  components: {
    XTable
  },
  props: {

  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      flowId: ''
    }
  },
  mounted () {
    // this.$emit('sendTitleToParent','借款申请');
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/launch/hr/personChangeApply.vue